import { Box, Button, Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import DialogHeader from '../DialogHeader';
import AddAssociateCDMOs from './AddAssociateCDMOs';

const useStyles = makeStyles((theme) => ({
  list: {
    width: '40vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      width: '80vw',
    },
  },
  backdrop: {
    '& .MuiBackdrop-root ': {
      backgroundColor: 'transparent !important',
      opacity: '0 !important',
    },
  },
}));

const UpdateAssociatedCDMOs = (props) => {
  const { warehouseDetails, handleClose } = props;
  const classes = useStyles();
  const [selectedCDMOs, setSelectedCDMOs] = useState([]);
  const [error, setError] = useState(null);

  const handleChangeCMOList = (type,val) => {
    setSelectedCDMOs(val)
  }

  return (
    <div className={classes.list}>
      <Grid
        container
        justifyContent='center'
        alignItems='center'
        style={{ padding: '1rem' }}
      >
        <Grid item xs={12}>
          <DialogHeader header={'Update CDMOs'} />
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              style={{
                whiteSpace: 'nowrap',
                fontSize: '1.5rem',
                fontWeight: '500',
                paddingBottom: '10px',
                justifySelf: 'flex-start',
              }}
            >
              {warehouseDetails.warehouseName}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <AddAssociateCDMOs selectedCMOs={selectedCDMOs} handleChangeCMOList={handleChangeCMOList} errors={error} />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent='center'
        alignItems='center'
        style={{ padding: '1rem' }}
      >
        <Grid item xs={12}>
        <Typography
        style={{
          fontWeight: "500",
          marginBottom: "8px",
          color: "black",
        }}
      >
        Warning:
          </Typography>
          <Box
      display="flex"
      flexDirection="column"
      border="1px solid #f44336"
      borderRadius="4px"
      padding="16px"
      bgcolor="#fff"
    >
      <Typography
        variant="body2"
        style={{
          color: "#f44336",
        }}
      >
        Associated CMOs change: You are changing the list of CMOs associated
        with the warehouse. CMO team members may lose access to certain areas
        of the application.
      </Typography>
    </Box>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '1rem',
            alignContent: 'flex-end',
          }}
        >
        <Button
          variant='outlined'
          style={{ textTransform: 'none' }}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          color='secondary'
          style={{ textTransform: 'none' }}
        >
          Save Changes
        </Button>

        </Grid>
      </Grid>
    </div>
  );
};

export default UpdateAssociatedCDMOs;
